export const en = {
  'contact.header': 'Contact info',

  'contacts.header': 'My contacts',
  'contacts.create': 'New contact',
  'contacts.edit': 'Edit contact',

  'welcome.header': 'Welcome page',
  'welcome.login-form.email': 'Email',
  'welcome.login-form.password': 'Password',

  'events.header': 'My events',
  'events.create': 'New event',
  'events.edit': 'Edit event',

  'home.header': 'Home',
  'profile.header': 'My Profile',
  'profile.logout': 'Log Out',
  'settings.header': 'My settings',
  'forgot-login.header': 'Forgot Password',
  'forgot-login.button.reset': 'e-mail reset instructions',

  'registration.header': 'Free Member Registration',
  'registration.form.country': 'Country',
  'registration.form.language': 'Language',
  'registration.button.continue': 'Continue to Setup your Account',
  'registration.button.sign-in': 'Sign In',
  'registration.text.acknowledge':
    'By creating an account, you acknowledge that you have read our Privacy Policy and agree to our Terms of Use.',
  'registration.text.registered': 'Already have an Account?',

  'validation.messages.required': 'Required',
  'validation.messages.length': 'Length should be {0} - {1} symbols',
  'validation.messages.email': 'Entered value is not a valid email',

  'button.submit': 'Submit',
  'button.login': 'Login',
  'button.back': 'Back',
  'button.cancel': 'Cancel',
  'button.settings': 'Settings',
  'button.forgot-login': 'Forgot Password',
  'button.registration': 'Free Member Registration',

  'menu.admin': 'Admin',
  'menu.lots-empty': 'Empty Lots',
  'menu.lots': 'Lots',
  'menu.waybills': 'Waybills',
  'menu.waybill-imports': 'PDF Imports',
  'menu.bvs': 'BVs',
  'menu.campaigns': 'Campaigns',
  'menu.dashboard-global': 'Global Dashboard',
  'menu.consortiums': 'Consortiums',
  'menu.counterparties': 'Company Book',
  'menu.cvs': 'CVs',
  'menu.cv-group': 'CVs',
  'menu.cv-executions': 'CV Execution',
  'menu.products': 'Products',
  'menu.addresses': 'Address Book',
  'menu.counterparty-contracts': 'Contracts',
  'menu.contract-line-items': 'Fixings',
  'menu.proposal': 'Proposal',
  'menu.boardings': 'Boardings',
  'menu.boarding-imports': 'SI Imports',
  'menu.transit-orders': 'Transit Orders',
  'menu.containers': 'Containers',
  'menu.transfers': 'Transfers',
  'menu.formulas': 'Formulas',
  'menu.cooperatives': 'Cooperatives',
  'menu.farmers': 'Farmers',
  'menu.farms': 'Farms',
  'menu.attachment-history': 'File History',

  // Admin descriptions
  'menu.campaigns.description': 'Manage campaigns',
  'menu.counterparties.description': 'Company book and counterparties',
  'menu.consortiums.description': 'Manage consortiums',
  'menu.cooperatives.description': 'Manage cooperatives',
  'menu.farmers.description': 'Manage farmers',
  'menu.farms.description': 'Manage farms',
  'menu.products.description': 'Manage products catalog',
  'menu.addresses.description': 'Address book',
  'menu.containers.description': 'Manage containers',

  // Common pages
  'common.access-denied.title': 'Access Denied',
  'common.access-denied.p1': "You don't have permissions to access this page.",
  'common.access-denied.p2': 'For more details, please contact customer support.',
  'common.back-home': 'Back Home',
  'common.warning': 'Warning',
  'common.search': 'Search...',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.unknown': 'Unknown',
  'common.note': 'Note',
  'common.month.1': 'January',
  'common.month.2': 'February',
  'common.month.3': 'March',
  'common.month.4': 'April',
  'common.month.5': 'May',
  'common.month.6': 'June',
  'common.month.7': 'July',
  'common.month.8': 'August',
  'common.month.9': 'September',
  'common.month.10': 'October',
  'common.month.11': 'November',
  'common.month.12': 'December',

  // Table
  'table.actions': 'Actions',
  'table.edit': 'Edit',
  'table.delete': 'Delete',
  'table.report': 'Report',
  'table.download': 'Download',
  'table.notes': 'Notes',

  // Admin
  'admin.title': 'Admin page',
  'admin.section.partners': 'Partners & counterparties',
  'admin.section.catalog': 'Catalog',
  'admin.section.logistics': 'Addresses & logistics',
  'admin.section.other': 'Other',
  'admin.section.audit': 'Audit',
  'menu.attachment-history.description': 'History of all uploaded attachments',

  // Addresses
  'addresses.add-new': 'Add Address',
  'addresses.create-new': 'Create Address',
  'addresses.address-number': 'Address #{0}',
  'addresses.name': 'Name',
  'addresses.type': 'Type',
  'addresses.country': 'Country',
  'addresses.city': 'City',
  'addresses.street': 'Street',
  'addresses.street2': 'Street 2',

  // BVs
  'bvs.add-new': 'Add BV',
  'bvs.create-new': 'Create BV',
  'bvs.bv-number': 'BV #{0}',
  'bvs.number': 'Number',
  'bvs.name': 'Name',
  'bvs.status': 'Status',
  'bvs.acceptance-date': 'Acceptance Date',
  'bvs.expiration-date': 'Expiration Date',
  'bvs.lots': 'Lots',
  'bvs.status.BV': 'BV',
  'bvs.status.BA': 'BA',
  'bvs.status.BV request made': 'BV request made',
  'bvs.status.BV to ask': 'BV to ask',
  'bvs.status.Request for extension': 'Request for extension',
  'bvs.status.Rework request made': 'Rework request made',

  // Campaigns
  'campaigns.add-new': 'Add Campaign',
  'campaigns.create-new': 'Create Campaign',
  'campaigns.campaign-number': 'Campaign #{0}',
  'campaigns.formIntroTitle': 'How seasons and imports work',
  'campaigns.formIntroDescription':
    'One campaign row defines both main crop and mid crop windows. Waybills and lots resolve campaign from an event date (e.g. weighing/analysis or production): the date must fall in either window. Exactly one campaign must match that date; zero matches or more than one (overlapping seasons) stop the import.\n\nThe name must follow [YYYY] Title or [YYYY - YYYY] Title (space after ]). The first bracket year is the season anchor and fills the Year field below automatically — you only edit the name. With two years in brackets, the second year pins mid crop to the correct calendar year when main spans two years; with [YYYY] only, mid follows the anchor year alone.\n\nThe anchor year is not the calendar year of every event. When the main window wraps across 1 January (start month/day later in the year than the end), dates on the first segment use the anchor calendar year and dates after New Year use the following year — e.g. anchor 2024 with main Oct 2024–Mar 2025 means March in that window is March 2025. Typical defaults are Oct–Mar and Apr–Sep; month and day values can be adjusted per deployment (within validation).',
  'campaigns.formIntroHelpAriaLabel': 'More about how seasons and imports work',
  'campaigns.sectionIdentity': 'Name and season key',
  'campaigns.sectionMainCrop': 'Main crop window',
  'campaigns.sectionMidCrop': 'Mid crop window',
  'campaigns.name': 'Name',
  'campaigns.namePatternError': 'Use [YYYY] Title or [YYYY - YYYY] Title (space after ]).',
  'campaigns.nameExtra':
    'Use [YYYY] Title or [YYYY - YYYY] Title (space after ]). The title after the brackets is free text. The two-year form is not only display: the second bracket year helps place mid crop in the right calendar year when main crosses a year boundary. Example: [2024 - 2025] Campaign. The first bracket year sets the anchor year below automatically.',
  'campaigns.year': 'Season anchor year',
  'campaigns.yearExtra':
    "Auto-filled from the first bracket year of the name. It is the anchor calendar year for the first segment of the main window when it wraps New Year's (rule of thumb: the calendar year of the autumn start). Example: name [2024 - 2025] Campaign → 2024.",
  'campaigns.mainStartMonth': 'Main crop — start month',
  'campaigns.mainStartDay': 'Main crop — start day',
  'campaigns.mainEndMonth': 'Main crop — end month',
  'campaigns.mainEndDay': 'Main crop — end day',
  'campaigns.mainWindowExtra':
    'When start is later in the year than end, the window wraps: the end lies in the next calendar year (e.g. Oct→Mar). Defaults are often Oct–Mar; month/day can be changed within validation.',
  'campaigns.midStartMonth': 'Mid crop — start month',
  'campaigns.midStartDay': 'Mid crop — start day',
  'campaigns.midEndMonth': 'Mid crop — end month',
  'campaigns.midEndDay': 'Mid crop — end day',
  'campaigns.midWindowExtra':
    'Typically within one calendar year (e.g. Apr–Sep). Same campaign row as main crop. Which calendar year applies follows the anchor Year and, for [YYYY - YYYY] names, the second bracket year.',

  // Cooperatives
  'cooperative.isEudrCompliant': 'EUDR Compliant',
  'cooperatives.add-new': 'Add Cooperative',
  'cooperatives.create-new': 'Create Cooperative',
  'cooperatives.cooperative-number': 'Cooperative #{0}',

  // Consortiums
  'consortiums.add-new': 'Add Consortium',
  'consortiums.create-new': 'Create Consortium',
  'consortiums.consortium-number': 'Consortium #{0}',
  'consortiums.cooperatives': 'Cooperatives',

  // Counterparties
  'counterparties.add-new': 'Company',
  'counterparties.create-new': 'Create Company',
  'counterparties.counterparties-number': 'Company #{0}',
  'counterparties.name': 'Name',
  'counterparties.code': 'Code',
  'counterparties.type': 'Type',
  'counterparties.cooperative.code': 'Code',
  'counterparties.consortium': 'Belongs to Consortium',
  'counterparties.cooperative.title': 'Associated Cooperatives',
  'cooperatives.isEudrCompliant': 'EUDR Compliant',

  // Countcerparty Contracts
  'counterparty-contracts.add-new': 'Add Contract',
  'counterparty-contracts.create-new': 'Create Contract',
  'counterparty-contracts.contract-number': 'Contract #{0}',
  'counterparty-contracts.counterparty': 'Counterparty',
  'counterparty-contracts.client': 'Client',
  'counterparty-contracts.client-contract': 'Client Contract',
  'counterparty-contracts.shipowner-contract': 'Shipowner Contract',
  'counterparty-contracts.shipping-contract': 'Shipping Contract',
  'counterparty-contracts.volume': 'Volume',
  'counterparty-contracts.price': 'Price',
  'counterparty-contracts.statistics': 'Statistics',
  'counterparty-contracts.accepted': 'Accepted',
  'counterparty-contracts.pending': 'Proposed',
  'counterparty-contracts.received': 'Received',
  'counterparty-contracts.sampling': 'Sampling',
  'counterparty-contracts.proposed': 'To Be Proposed',
  'counterparty-contracts.total': 'Total',
  'counterparty-contracts.quality': 'Quality',
  'counterparty-contracts.grain': 'Grain',

  // Contract Line Items
  'contract-line-items.add-new': 'Add Contract Fixing',
  'contract-line-items.create-new': 'Create Contract Fixing',
  'contract-line-items.line-item-number': 'Contract Fixing #{0}',
  'contract-line-items.client': 'Client',
  'contract-line-items.exporter': 'Exporter',
  'contract-line-items.final-contract': 'Final Contract',
  'contract-line-items.number': 'Number',
  'contract-line-items.volume': 'Volume',
  'contract-line-items.product': 'Product',
  'contract-line-items.execution-period': 'Execution Period',
  'contract-line-items.boarding-period': 'Boarding Period',
  'contract-line-items.differential': 'Differential',
  'contract-line-items.material-fixing-date': 'Material Fixing Date',
  'contract-line-items.currency-fixing-date': 'Currency Fixing Date',
  'contract-line-items.fixing-price-gbp': 'Fixing Price Gbp',
  'contract-line-items.total-fob-price': 'Total Fob Price',
  'contract-line-items.price-quality': 'Price Quality',
  'contract-line-items.cyrian-basic-price': 'Cyrian Basic Price',
  'contract-line-items.cyrian-discount': 'Cyrian Discount',
  'contract-line-items.graining': 'Graining',
  'contract-line-items.signature': 'Signature',

  // Contract Product
  'contract-product.product': 'Product',
  'contract-product.quality': 'Quality',
  'contract-product.gr': 'gr',
  'contract-product.volume': 'Volume',

  // CVs
  'cvs.add-new': 'Add Unlocking CV',
  'cvs.create': 'Create Unlocking CV',
  'cvs.cv-number': 'CV #{0}',
  'cvs.name': 'Name',
  'cvs.number': 'Number',
  'cvs.volume': 'Volume',
  'cvs.price': 'Price',
  'cvs.currency': 'Currency',
  'cvs.taxes': 'Taxes',
  'cvs.counterparty': 'Counterparty',
  'cvs.campaign': 'Campaign',
  'cvs.period': 'Unlocking Period',
  'cvs.unlocking-date': 'Unlocking Date',
  'cvs.cv-unlocking': 'CV Unlocking',
  'cvs.balance': 'Balance',

  // CV Executions
  'cv-executions.add-new': 'Add Execution CV',
  'cv-executions.create': 'Create CV Execution',
  'cv-executions.edit-number': 'CV Execution #{0}',
  'cv-executions.counterparty': 'Counterparty',
  'cv-executions.cv-unlocking': 'CV Unlocking',
  'cv-executions.cv-execution': 'CV Execution',
  'cv-executions.unlocking-period': 'Unlocking Period',
  'cv-executions.execution-period': 'Execution Period',
  'cv-executions.campaign': 'Campaign',
  'cv-executions.volume': 'Volume',
  'cv-executions.price': 'Price',
  'cv-executions.number': 'Number',
  'cv-executions.unlocking-date': 'Unlocking Date',

  // Lots
  'lots.filter-all': 'All',
  'lots.filter-empty-only': 'Empty lots only',
  'lots.add-new': 'Add Lot',
  'lots.mass-add-new': 'Add Lots',
  'lots.mass-remove': 'Delete Lots',
  'lots.mass-add-pledges': 'Add Pledges',
  'lots.mass-add-fumigation': 'Add Fumigation',
  'lots.mass-add-bv': 'Add BV',
  'lots.associate-product': 'Associate Product',
  'lots.clearAllFilters': 'Clear all filters',
  'lots.create-new': 'Create Lot',
  'lots.create-from-excel': 'Create from Excel',
  'lots.lot-number': 'Lot #{0}',
  'lots.count': 'Count',
  'lots.unblock-cv': 'Unblock Cv',
  'lots.execution-cv': 'Execution Cv',
  'lots.bv': 'BV',
  'lots.bv-expiration-date': 'BV Expiration Date',
  'lots.campaign': 'Campaign',
  'lots.proposal-contract': 'Proposal Contract',
  'lots.proposal-status': 'Proposal Status',
  'lots.owner': 'Owner',
  'lots.final-client': 'Final Client',
  'lots.product': 'Type of cacao',
  'lots.production-status': 'Lot status',
  'lots.fo': 'FO',
  'lots.to': 'To',
  'lots.containers': 'Containers',
  'lots.number': 'Lot Number',
  'lots.sacks-quantity': 'Number of bags',
  'lots.theoretical-weight': 'Theoretical weight',
  'lots.weight': 'Weight',
  'lots.fo1': 'N° Fo1',
  'lots.mass-create-warn': 'Lots #{0} already exist',
  'lots.mass-create-warn2': 'Some lots already exist',
  'lots.factory': 'Factory',
  'lots.location': 'Location',
  'lots.final-contract': 'Final Contract',
  'lots.production-date': 'Production Date',
  'lots.quality': 'Quality',
  'lots.delete-warning-title': 'Warning',
  'lots.delete-warning-desc': 'Are you sure you want to delete these lots?',

  'lots.production-status.To produce': 'To produce',
  'lots.production-status.Under production': 'Under production',
  'lots.production-status.Produced': 'Produced',

  'lots.events': 'Lot Events',
  'lots.events.id': 'Id',
  'lots.events.type': 'Type',
  'lots.events.namespace': 'Namespace',
  'lots.events.comment': 'Comment',
  'lots.events.date': 'Date',
  'lots.pull-report': 'Pull report',
  'lots.export.title': 'Export report ({0} lots)',
  'lots.export.no-selection': 'No lots selected. Go back and select lots to export.',
  'lots.export.download': 'Export to Excel',
  'lots.export.polygon-banner': '{0} / {1} plots have a polygon',
  'lots.export.section.cooperatives': 'Cooperatives',
  'lots.export.section.farmers': 'Farmers & Volumes',
  'lots.export.section.polygons': 'Polygons',
  'lots.export.tab.summary': 'Summary',
  'lots.export.tab.cooperatives': 'Cooperatives',
  'lots.export.tab.farmers': 'Farmers & Volumes',
  'lots.export.tab.polygons': 'Polygons',
  'lots.export.col.lot': 'Lot',
  'lots.export.col.product': 'Product',
  'lots.export.col.cooperatives-count': 'Cooperatives count',
  'lots.export.col.farmers-count': 'Farmers count',
  'lots.export.col.lot-weight': 'Lot weight (kg)',
  'lots.export.col.polygon-coverage': 'Polygon coverage',
  'lots.export.col.cooperative': 'Cooperative',
  'lots.export.col.code': 'Code',
  'lots.export.col.consortium': 'Consortium',
  'lots.export.col.deliveries': 'Deliveries',
  'lots.export.col.supplied-kg': 'Supplied (kg)',
  'lots.export.col.bags': 'Bags',
  'lots.export.col.farmer': 'Farmer',
  'lots.export.col.farmer-id': 'Farmer ID',
  'lots.export.col.delivery': 'Delivery',
  'lots.export.col.volume-kg': 'Volume (kg)',
  'lots.export.col.plots-total': 'Plots total',
  'lots.export.col.with-polygon': 'With polygon',
  'lots.export.col.coverage-percent': 'Coverage %',
  'lots.export.section.waybills': 'Waybills',
  'lots.export.tab.waybills': 'Waybills',
  'lots.export.col.waybill': 'Waybill',
  'lots.export.col.campaign': 'Campaign',
  'lots.export.col.declared-net-weight-kg': 'Declared net weight (kg)',
  'lot.edit': 'Edit Lot',

  // Lot Analysis
  'lot.analysis': 'Analysis',
  'lot.analysis.title': 'Analysis for Lot #{0}',
  'lot.analysis.address': 'Address',
  'lot.bv': 'BV',
  'lot.analysis.counterparty': 'Counterparty',
  'lot.analysis.analysis-date': 'Analysis Date',
  'lot.analysis.sampling-date': 'Sampling Date',
  'lot.analysis.sampling-method': 'Sampling Method',
  'lot.analysis.analysis-reference': 'Analysis Reference',
  'lot.analysis.sampling-reference': 'Sampling Reference',
  'lot.analysis.classification': 'Classification',
  'lot.analysis.document-url': 'Document Url',
  'lot.analysis.total-sample-weight': 'TotalSample Weight',
  'lot.analysis.specific-weight-100g': 'Specific Weight On 100g',
  'lot.analysis.graining': 'Graining',
  'lot.analysis.humidity': 'Humidity',
  'lot.analysis.screening-scrap': 'Screening Scrap',
  'lot.analysis.flat-beans': 'Flat Beans',
  'lot.analysis.crabots': 'Crabots',
  'lot.analysis.foreign-bodies': 'Foreign Bodies',
  'lot.analysis.broken-beans': 'Broken Beans',
  'lot.analysis.fragments': 'Fragments',
  'lot.analysis.shell': 'Shell',
  'lot.analysis.materials-derived': 'Materials Derived',
  'lot.analysis.moldy': 'Moldy',
  'lot.analysis.moths': 'Moths',
  'lot.analysis.slate': 'Slate',
  'lot.analysis.germinated': 'Germinated',
  'lot.analysis.violets': 'Violets',
  'lot.analysis.buttered': 'Buttered',

  // Lot Fumigation
  'lot.fumigation': 'Fumigation',
  'lot.fumigation.title': 'Fumigation for Lot #{0}',
  'lot.fumigation.location': 'Location',
  'lot.fumigation.start-date': 'Start Date',
  'lot.fumigation.end-date': 'End Date',

  // Lot Pledge
  'lot.pledge': 'Pledge',
  'lot.pledge.title': 'Pledge for Lot #{0}',
  'lot.product.title': 'Associate Product for Lots #{0}',
  'lot.pledge.counterparty': 'Counterparty',
  'lot.pledge.request-number': 'Request Number',
  'lot.pledge.ltd-number': 'ltdNumber',
  'lot.pledge.das-dae': 'dasDae',

  // Lot Weighing
  'lot.weighing': 'Weighing',
  'lot.weighing.title': 'Weighing for Lot #{0}',
  'lot.weighing.address': 'Address',
  'lot.weighing.counterparty': 'Counterparty',
  'lot.weighing.date': 'Date',
  'lot.weighing.weight': 'Weight',

  'lots.link-lots-waybills': 'Import Processing Report',
  'lots.processingReportTemplate': 'Report template',
  'lots.link-lots-waybills.factory-not-found-title': 'Factory address not found',
  'lots.link-lots-waybills.factory-not-found-desc':
    'The processing report template "{0}" requires a matching Factory address, which doesn\'t exist in the database yet. Create it under Addresses, then import the report again.',
  'lots.link-lots-waybills.factory-not-found-action': 'Go to Addresses',
  'lots.waybills.relatedLots': 'Related Lots',

  // Products
  'products.add-new': 'Add Product',
  'products.create-new': 'Create Product',
  'products.product-number': 'Product #{0}',
  'products.name': 'Name',
  'products.type': 'Type',
  'products.sampling-method': 'Sampling Method',
  'products.type.Ordinary': 'Ordinary',
  'products.quality.Low': 'Low',
  'products.quality.Medium': 'Medium',
  'products.quality.High': 'High',
  'products.quality.G1': 'G1',
  'products.quality.G2': 'G2',
  'products.quality.SG': 'SG',
  'products.type.Utz': 'Utz',
  'products.type.Fair trade': 'Fair trade',
  'products.type.Rainforest alliance': 'Rainforest alliance',
  'products.type.Cocoa Life': 'Cocoa Life',
  'products.type.Premius Cyrian': 'Premius Cyrian',

  // Attachments
  'attachments.attachments': 'Attachments',
  'attachments.title': 'Attachments for #{0}',
  'attachments.uploading': 'Uploading',
  'attachments.start-upload': 'Start Upload',
  'attachments.name': 'Name',
  'attachments.created': 'Created',
  'attachments.Size': 'Size',

  // Proposal
  'proposal.create': 'Create Proposal for Lot #{0}',
  'proposal.add-many': 'Add Proposals',
  'proposal.update': 'Update Proposal #{0}',
  'proposal.new-status': 'New Proposal Status',
  'proposal.status': 'Status',
  'proposal.update-status': 'Update Proposal Status for Lot #{0}',
  'proposal.mass-update-status': 'Mass Update Proposal Status',
  'proposal.contract-initial': 'Contract Client Initial',
  'proposal.contract-final': 'Contract Client Final',
  'proposal.mass-sampling': 'Mass Sampling',
  'proposal.mass-accepted': 'Mass Accepted',
  'proposal.mass-rejected': 'Mass Rejected',
  'proposal.customer': 'Client',
  'proposal.selected-lots': 'Selected Lots',
  'proposal.code': 'Code',
  'proposal.status.withdrawn': 'With Drawn',
  'proposal.status.pending': 'Pending',
  'proposal.status.accepted': 'Accepted',
  'proposal.status.rejected': 'Rejected',

  // Boardings
  'boardings.add-new': 'Add Boarding',
  'boardings.create-new': 'Create Boarding',
  'boardings.boarding-number': 'Boarding #{0}',
  'boardings.contract': 'Contract',
  'boardings.container': 'Container',
  'boardings.departure-address': 'Departure Port',
  'boardings.internal-client': 'Internal client',
  'boardings.final-client': 'Final client',
  'boardings.consignee': 'Consignee',
  'boardings.final-consignee': 'Final consignee',
  'boardings.freight-payer': 'Freight payer',
  'boardings.internal-client-contract': 'Contract for internal client',
  'boardings.final-client-contract': 'Contract for final client',
  'boardings.service-contract': 'Contract of service',
  'boardings.notify': 'Notify',
  'boardings.sea-line': 'Sea line',
  'boardings.product': 'Product',
  'boardings.harbor-address': 'Harbor Address',
  'boardings.destination-address': 'Destination Port',
  'boardings.campaign': 'Campaign',
  'boardings.exporter': 'Exporter',
  'boardings.inspector': 'Inspector',
  'boardings.shipowner': 'Shipowner',
  'boardings.courier': 'Courier',
  'boardings.container-type': 'Type of containers',
  'boardings.number': 'Number',
  'boardings.volume': 'Volume',
  'boardings.date': 'Date of instruction',
  'boardings.warning': 'Warning',
  'boardings.warning-product-not-contract': 'You selected product other than the contract stated',
  'boardings.si-number': 'SI number',
  'boardings.quantity-mt': 'Quantity (MT)',
  'boardings.certification-level': 'Certification level',
  'boardings.packing': 'Packing',
  'boardings.pending-amendment': 'Pending amendment',
  'boardings.pending-amendment-tooltip':
    'An unapproved SI amendment references this boarding — approving it on the SI Imports page will update this boarding.',
  'boardings.imports.title': 'Shipping Instruction imports',
  'boardings.imports.subtitle':
    'Client SIs arrive by email and are parsed automatically — review each one to create or update a boarding',
  'boardings.imports.refresh': 'Refresh',
  'boardings.imports.badge.reused':
    'Linked to import #{id} — same document; this row takes its extracted data from that import.',
  'boardings.imports.column.file': 'File',
  'boardings.imports.column.si-number': 'SI number',
  'boardings.imports.column.status': 'Status',
  'boardings.imports.column.created': 'Created',
  'boardings.imports.column.result': 'Result',
  'boardings.imports.column.actions': 'Actions',
  'boardings.imports.status.pending': 'In queue',
  'boardings.imports.status.parsed': 'Processing…',
  'boardings.imports.status.persisted': 'Approved',
  'boardings.imports.status.review': 'Needs review',
  'boardings.imports.status.failed': 'Failed',
  'boardings.imports.result.boarding-link': 'Boarding #{id}',
  'boardings.imports.result.amendment': 'Amendment of boarding #{id}',
  'boardings.imports.result.amendment-tooltip':
    'This SI number matches boarding #{id} — approving will update that boarding instead of creating a new one.',
  'boardings.imports.result.warnings': '{count, plural, one {# warning} other {# warnings}}',
  'boardings.imports.actions.review': 'Review & approve',
  'boardings.imports.actions.force-reparse': 'Force re-parse',
  'boardings.imports.actions.force-reparse-confirm-persisted':
    'Re-run AI extraction on this document? A new import row is created; existing rows are kept. The linked boarding and the existing rows only change after you approve the fresh result.',
  'boardings.imports.actions.force-reparse-confirm-other':
    'Re-run AI extraction on this document? A new import row is created; this row is kept and points to it. No boarding is linked yet, so this is just a fresh OCR run.',
  'boardings.imports.delete.unreachable':
    "Couldn't reach the server. Your delete may not have completed — please refresh to verify.",
  'boardings.imports.mailbox.last-checked': 'Mailbox last checked: {when}',
  'boardings.imports.mailbox.never': 'never',
  'boardings.imports.mailbox.min-ago': '{minutes, plural, =0 {just now} one {# minute ago} other {# minutes ago}}',
  'boardings.imports.quarantine.title': 'Quarantined emails ({count})',
  'boardings.imports.quarantine.column.received': 'Received',
  'boardings.imports.quarantine.column.from': 'From',
  'boardings.imports.quarantine.column.subject': 'Subject',
  'boardings.imports.quarantine.column.reason': 'Reason',
  'boardings.imports.quarantine.dismiss': 'Dismiss',
  'boardings.imports.quarantine.dismiss-confirm':
    'Dismiss this email? The record is kept for audit, but it will leave the quarantine list.',
  'boardings.imports.quarantine.dismissed': 'Email dismissed',
  'boardings.imports.review.title': 'Review shipping instruction',
  'boardings.imports.review.banner.amendment':
    'This SI number matches boarding #{id} — approving will update that boarding, not create a new one.',
  'boardings.imports.review.banner.create': 'No existing boarding matches this SI number — approving will create one.',
  'boardings.imports.review.banner.low_confidence':
    'OCR could not read some fields confidently. Review the highlighted entries and correct them before approving.',
  'boardings.imports.review.banner.entity_not_found':
    "Some values didn't match master data. Fix the highlighted fields or create the missing records, then approve again.",
  'boardings.imports.review.uncertain_field_tooltip':
    'OCR flagged this field as low confidence. Verify against the original document.',
  'boardings.imports.review.required': 'This field is required.',
  'boardings.imports.review.submit': 'Approve',
  'boardings.imports.review.cancel': 'Cancel',
  'boardings.imports.review.submit_success': 'Shipping instruction approved.',
  'boardings.imports.review.submit_parked':
    'Approve did not go through — some references could not be resolved. Check the highlighted fields.',
  'boardings.imports.review.submit_failed': 'Approve failed.',
  'boardings.imports.review.section.extracted': 'Extracted from document',
  'boardings.imports.review.section.approval': 'Approval details',
  'boardings.imports.review.siNumber': 'SI number',
  'boardings.imports.review.quantityMt': 'Quantity (MT)',
  'boardings.imports.review.purchaseContractNumber': 'Purchase contract no.',
  'boardings.imports.review.serviceContractNumber': 'Service contract no.',
  'boardings.imports.review.destination': 'Destination port',
  'boardings.imports.review.consignee': 'Consignee',
  'boardings.imports.review.freightPayer': 'Freight payer',
  'boardings.imports.review.notifyParties': 'Notify parties',
  'boardings.imports.review.shippingLine': 'Shipping line',
  'boardings.imports.review.containerType': 'Container type',
  'boardings.imports.review.packing': 'Packing',
  'boardings.imports.review.certificationLevel': 'Certification level',
  'boardings.imports.review.lotNumbers': 'Lot numbers',
  'boardings.imports.review.requiredDocuments': 'Required documents',
  'boardings.imports.review.date': 'Boarding date',
  'boardings.imports.review.exporter': 'Exporter',
  'boardings.imports.review.number': 'Boarding number',
  'boardings.imports.review.number-placeholder': 'Defaults to the SI number',
  'boardings.imports.review.product': 'Product',
  'boardings.imports.review.product-placeholder': 'Auto — derived from the purchase contract',
  'boardings.imports.review.container': 'Container',
  'boardings.imports.review.container-placeholder': 'Auto — resolved from the container type',
  'boardings.imports.review.harbor.create_inline': 'Create harbor',
  'boardings.imports.review.harbor.create_missing': 'Destination name is required before creating a new record.',
  'boardings.imports.review.harbor.create_success': 'Harbor {name} created.',
  'boardings.imports.review.harbor.already_exists': 'Harbor {name} already exists. No new record was created.',
  'boardings.imports.review.harbor.dup_check_overflow':
    'Too many harbors to verify duplicates safely — create the harbor in Admin → Addresses instead.',

  // Transit Orders
  'transit-orders.add-new': 'Add Transit Order',
  'transit-orders.create-new': 'Create Transit Order',
  'transit-orders.transit-order-number': 'Transit Order #{0}',
  'transit-orders.boarding': 'Boarding',
  'transit-orders.order-number': 'Order Number',
  'transit-orders.booking-number': 'Booking Number',
  'transit-orders.bill-of-lading-number': 'Bill Of Lading Number',
  'transit-orders.forwarder-file-number': 'Forwarder File Number',
  'transit-orders.ship-name': 'Ship Name',
  'transit-orders.good-to-embark': 'Good To Embark',
  'transit-orders.net-weight': 'Net Weight',
  'transit-orders.eta-date': 'Eta Date',
  'transit-orders.swb-date': 'Swb Date',
  'transit-orders.available-bv-volume': 'Available Bv Volume For Formula',
  'transit-orders.formulas-launched': 'Formulas Launched',
  'transit-orders.gross-weight-diff': 'Net Weight Gross Weight Diff',
  'transit-orders.theoretical-weight': 'Theoretical Weight',
  'transit-orders.container': 'Container',
  'transit-orders.departure-address': 'Departure Port',
  'transit-orders.internal-client': 'Internal client',
  'transit-orders.final-client': 'Final client',
  'transit-orders.consignee': 'Consignee',
  'transit-orders.final-consignee': 'Final consignee',
  'transit-orders.freight-payer': 'Freight payer',
  'transit-orders.internal-client-contract': 'Contract for internal client',
  'transit-orders.final-client-contract': 'Contract for final client',
  'transit-orders.service-contract': 'Contract of service',
  'transit-orders.freight-forwarder': 'Freight Forwarder',
  'transit-orders.product': 'Product',
  'transit-orders.exporter': 'Exporter',
  'transit-orders.destination-address': 'Destination Port',

  // Containers
  'containers.add-new': 'Add Container',
  'containers.create-new': 'Create Container',
  'containers.container-number': 'Container #{0}',
  'containers.name': 'Name',
  'containers.type': 'Type',
  'containers.sacs-type': 'Sacs Type',
  'containers.dressing-material': 'Dressing Material',

  // Transfers
  'transfers.add-new': 'Add Transfer',
  'transfers.create-new': 'Create Transfer',
  'transfers.transfer-number': 'Transfer #{0}',
  'transfers.product': 'Product',
  'transfers.campaign': 'Campaign',
  'transfers.carrier': 'Carrier',
  'transfers.transport-charge-counterparty': 'Transport Charge Counterparty',
  'transfers.loading-counterparty': 'Loading Counterparty',
  'transfers.start-location': 'Start Location',
  'transfers.end-location': 'End Location',
  'transfers.number': 'Number',
  'transfers.status': 'Status',
  'transfers.phyto-position': 'Phyto Position',
  'transfers.phyto-treatment-days': 'Phyto Treatment Days',
  'transfers.phone-number': 'Phone Number',
  'transfers.status.arrived': 'Arrived',
  'transfers.status.departed': 'Departed',
  'transfers.status.in transit': 'In transit',

  // User Settings
  'user-settings.items-per-page': 'Items by page',
  'user-settings.dump-data': 'Dump data',
  'user-settings.title': 'Settings',

  // Profile
  'profile.title': 'Profile',
  'profile.email': 'Email',
  'profile.name': 'Name',
  'profile.role': 'Role',

  // Formulas
  'formulas.add-new': 'Add Formula',
  'formulas.create-new': 'Create Formula',
  'formulas.formula-number': 'Formula #{0}',
  'formulas.exporter': 'Exporter',
  'formulas.freight-forwarder': 'Freight Forwarder',
  'formulas.product': 'Product',
  'formulas.campaign': 'Campaign',
  'formulas.destination': 'Destination',
  'formulas.departure-port': 'Departure Port',
  'formulas.recipient': 'Recipient',
  'formulas.execution-cv': 'Execution Cv',
  'formulas.authorization-number': 'Authorization Number',
  'formulas.harvest': 'Harvest',
  'formulas.grade': 'Grade',
  'formulas.quality': 'Quality',
  'formulas.net-weight': 'Net Weight',
  'formulas.gross-weight': 'Gross Weight',
  'formulas.packaging': 'Packaging',
  'formulas.packaging-count': 'Packaging Count',
  'formulas.customs-nomenclature': 'Customs Nomenclature',
  'formulas.ship': 'Ship',
  'formulas.fO1Date': 'fO1Date',

  // Formula Payments
  'formula.payment.payments': 'Payments',
  'formula.payment.add-new': 'Add Payment',
  'formula.payment.create-new': 'Create Payment',
  'formula.payment.payment-number': 'Payment #{0}',
  'formula.payment.type': 'Type',
  'formula.payment.weight': 'Weight',
  'formula.payment.rate': 'Rate',
  'formula.payment.support': 'Support',

  // Formula Taxes
  'formula.taxes.taxes': 'Taxes',
  'formula.taxes.add-new': 'Add Tax',
  'formula.taxes.create-new': 'Create Tax',
  'formula.taxes.tax-number': 'Tax #{0}',
  'formula.taxes.bank': 'Bank',
  'formula.taxes.price': 'Price',
  'formula.taxes.name': 'Name',
  'formula.taxes.check': 'Check',
  'formula.taxes.rate': 'Rate',
  'formula.taxes.date': 'Date',

  // Farmers
  'farmers.add-new': 'Add Farmer',
  'farmers.create-from-excel-by-type': 'Create from Excel',
  'farmers.id': 'ID',
  'farmers.identifier': 'Identifier',
  'farmers.farmerId': 'Farmer ID',
  'farmers.farmId': 'Farm ID',
  'farmers.firstName': 'First Name',
  'farmers.lastName': 'Last Name',
  'farmers.counterparty': 'Farmer Name',
  'farmers.cooperative': 'Cooperative',
  'farmers.farms': 'Farms',
  'farmers.gender': 'Gender',
  'farmers.phone': 'Phone',
  'farmers.dob': 'Date of Birth',
  'farmers.product': 'Product',
  'farmers.village': 'Village',
  'farmers.district': 'District',
  'farmers.region': 'Region',
  'farmers.surfaceAreaHa': 'Surface Area (ha)',
  'farmers.nationalId': 'National ID',
  'farmers.sourceDocumentType': 'Uploaded From',
  'farmers.plotsCount': 'Plots Count',
  'farmers.totalFarmAreaHa': 'Farm Area (ha)',
  'farmers.latitude': 'Latitude',
  'farmers.longitude': 'Longitude',
  'farmers.createdAt': 'Created At',
  'farmers.updatedAt': 'Updated At',
  'farmers.plotsTab': 'Plots',

  // Farmer Plots
  'farmer.farmer-plot.farmerId': 'Farmer ID',
  'farmer.farmer-plot.farmId': 'Farm ID',
  'farmer.farmer-plot.plotId': 'Plot ID',
  'farmer.farmer-plot.plotAreaHa': 'Plot Area (ha)',
  'farmer.farmer-plot.latitude': 'Latitude',
  'farmer.farmer-plot.longitude': 'Longitude',
  'farmer.farmer-plot.createdAt': 'Created At',
  'farmer.farmer-plot.updatedAt': 'Updated At',

  // Farms
  'farms.tabTitle': 'Farms',
  'farms.farmId': 'Farm ID',
  'farms.farmerId': 'Farmer ID',
  'farms.farmer': 'Farmer',
  'farms.product': 'Product',
  'farms.village': 'Village',
  'farms.district': 'District',
  'farms.region': 'Region',
  'farms.plotsCount': 'Plots Count',
  'farms.polygonsMap': 'Plot polygons',
  'farms.noPolygons': 'No polygon data for plots',
  'farms.open': 'Open',

  // Dashboard
  'dashboard.refresh': 'Refresh',
  'dashboard.totalAcceptedWeight': 'Total Accepted Weight',
  'dashboard.totalAcceptedBags': 'Total Accepted Bags',
  'dashboard.totalLotWeight': 'Total Lot Weight',
  'dashboard.totalLotsCount': 'Total Lots Count',
  'dashboard.farmersCount': 'Unique Farmers',
  'dashboard.cooperativesCount': 'Unique Cooperatives',
  'dashboard.others': 'Others',
  'dashboard.productSplit': 'Weight by Product',
  'dashboard.productName': 'Product',
  'dashboard.productWeight': 'Weight',
  'dashboard.harborSplit': 'Weight by Harbor',
  'dashboard.harborName': 'Harbor',
  'dashboard.harborWeight': 'Weight',
  'dashboard.consortiumSplit': 'Weight by Consortium',
  'dashboard.consortiumName': 'Consortium',
  'dashboard.consortiumWeight': 'Weight',
  'dashboard.emptyProductSplit':
    'No accepted weight by product in this period (waybill weighing lines may be missing — ensure recepjournalier import has run).',
  'dashboard.emptyHarborSplit':
    'No accepted weight by harbor in this period (waybill weighing lines or harbor assignment may be missing).',
  'dashboard.emptyConsortiumSplit':
    'No accepted weight by consortium in this period (cooperative–consortium links or weighing lines may be missing).',
  'dashboard.waybillKpiIncomplete':
    'Lots appear in this period but accepted weight from waybills is zero. Weighing analyses are created by the recepjournalier (or equivalent) import; linking lots to waybills alone does not populate those KPIs.',
  'dashboard.error.title': 'Failed to load dashboard data',
  'dashboard.error.subtitle': 'Sorry, something went wrong. Please try again later.',
  'dashboard.tryAgain': 'Try Again',
  'dashboard.admin.title': 'Administrator Actions',
  'dashboard.admin.description':
    'Manually trigger a statistics recalculation for a specific day. This is useful if past data was corrected or added late.',
  'dashboard.admin.recalculate': 'Recalculate',
  'dashboard.quickFilter.week': 'Current Week',
  'dashboard.quickFilter.month': 'Current Month',
  'dashboard.quickFilter.mainCrop': 'Main crop (selected campaign)',
  'dashboard.quickFilter.midCrop': 'Mid crop ({year})',
  'dashboard.filter.campaign': 'Campaign for season filters',
  'dashboard.filter.products': 'Filter by Product',
  'dashboard.filters.cardTitle': 'Filters',
  'dashboard.filters.periodTitle': 'Reporting period',
  'dashboard.filters.productsTitle': 'Products',
  'dashboard.filters.campaignSeasonTitle': 'Quick range — campaign seasons',
  'dashboard.filters.campaignSeasonHint':
    "Starts empty on purpose: the chart follows the reporting period only. Pick a campaign, then click Main or Mid crop to apply that campaign's season dates to the period.",

  // Waybills (refactored from bols)
  'waybills.add-new': 'Waybill',
  'waybills.create-new': 'Create Waybill',
  'waybills.waybill-number': 'Waybill #{0}',
  'waybills.product': 'Product',
  'waybills.campaign': 'Campaign',
  'waybills.waybillNumber': 'Waybill Number',
  'waybills.factory': 'Factory',
  'waybills.harbor': 'Harbor',
  'waybills.cooperative': 'Cooperative',
  'waybills.exporter': 'Exporter',
  'waybills.productNature': 'Product Nature',
  'waybills.status': 'Status',
  'waybills.status.IN_PROGRESS': 'In progress',
  'waybills.status.REFUSED': 'Refused',
  'waybills.status.DONE': 'Done',
  'waybills.clearAllFilters': 'Clear all filters',
  'waybills.create-from-excel': 'Waybills from excel',
  'waybills.createFromPdf': 'Bulk PDF imports',
  'waybills.imports.title': 'Waybill PDF imports',
  'waybills.imports.subtitle': 'Drop CEU waybill PDFs and walk away — Gemini parses each one in the background',
  'waybills.imports.dropzone.title': 'Click or drag PDF files here',
  'waybills.imports.dropzone.hint':
    'Multiple files supported. Each PDF queues an independent parse job. Max 30 MB per file.',
  'waybills.imports.status.queued': 'Waiting…',
  'waybills.imports.status.uploading': 'Uploading…',
  'waybills.imports.status.upload_failed': 'Upload failed',
  'waybills.imports.status.pending': 'In queue',
  'waybills.imports.status.parsed': 'Persisting…',
  'waybills.imports.status.persisted': 'Done',
  'waybills.imports.status.review': 'Needs review',
  'waybills.imports.status.failed': 'Failed',
  'waybills.imports.actions.retry': 'Retry',
  'waybills.imports.actions.delete': 'Delete',
  'waybills.imports.actions.remove': 'Remove',
  'waybills.imports.actions.retry-upload': 'Retry upload',
  'waybills.imports.leave-confirm.title': 'Leave this page?',
  'waybills.imports.leave-confirm.content':
    'Some uploads failed and are kept only on this page. If you leave, you will have to drop those PDFs again.',
  'waybills.imports.leave-confirm.ok': 'Leave',
  'waybills.imports.leave-confirm.cancel': 'Stay',
  'waybills.imports.badge.reused':
    'Linked to import #{id} — same PDF; this row takes its extracted data from that import.',
  'waybills.imports.actions.retry-tooltip': 'Retry persistence on stored parsed data',
  'waybills.imports.actions.review': 'Review & confirm',
  'waybills.imports.actions.force-reparse': 'Force re-parse',
  'waybills.imports.actions.force-reparse-confirm-persisted':
    'Re-run AI extraction on this PDF? A new import row is created; existing rows are kept and refreshed once the new result is persisted. The linked waybill will then be updated with fresh PDF data.',
  'waybills.imports.actions.force-reparse-confirm-other':
    'Re-run AI extraction on this PDF? A new import row is created; this row is kept and points to it. No waybill is linked yet, so this is just a fresh OCR run.',
  'waybills.imports.actions.reapply': 'Re-apply extracted data',
  'waybills.imports.actions.reapply-confirm':
    'Push the stored extracted data back into the linked waybill? No new AI extraction will run — this uses the data already saved from the original import.',
  'waybills.imports.review.title': 'Review extracted data',
  'waybills.imports.review.banner.low_confidence':
    'OCR could not read some fields confidently. Review the highlighted entries and correct them before saving.',
  'waybills.imports.review.banner.entity_not_found':
    "The highlighted value didn't match anything in the database. Before clicking Create, verify it against the original PDF — scanned codes frequently misread (e.g. 0↔8↔6, S↔5). If the value is correct and the record is truly new, use Create cooperative.",
  'waybills.imports.review.uncertain_field_tooltip':
    'OCR flagged this field as low confidence. Verify against the original PDF.',
  'waybills.imports.review.required': 'This field is required.',
  'waybills.imports.review.submit': 'Save and persist',
  'waybills.imports.review.cancel': 'Cancel',
  'waybills.imports.review.submit_success': 'Document saved and waybill linked.',
  'waybills.imports.review.cooperativeCode': 'Cooperative code',
  'waybills.imports.review.cooperativeName': 'Cooperative name',
  'waybills.imports.review.originDepartment': 'Origin department',
  'waybills.imports.review.cropPhase': 'Crop phase',
  'waybills.imports.review.certification': 'Certification',
  'waybills.imports.review.bagCount': 'Bag count',
  'waybills.imports.review.netWeightKg': 'Net weight (kg)',
  'waybills.imports.review.transportCostFcfa': 'Transport cost (FCFA)',
  'waybills.imports.review.editionDate': 'Edition date',
  'waybills.imports.review.cooperative.create_inline': 'Create cooperative',
  'waybills.imports.review.cooperative.create_confirm': 'Create cooperative {code} — {name}?',
  'waybills.imports.review.cooperative.create_missing':
    'Cooperative code and name are required before creating a new record.',
  'waybills.imports.review.cooperative.create_success': 'Cooperative {code} created.',
  'waybills.imports.review.cooperative.already_exists': 'Cooperative {code} already exists. No new record was created.',
  'waybills.imports.review.harbor.create_inline': 'Create harbor',
  'waybills.imports.review.harbor.create_missing': 'Harbor name is required before creating a new record.',
  'waybills.imports.review.harbor.create_success': 'Harbor {name} created.',
  'waybills.imports.review.harbor.already_exists': 'Harbor {name} already exists. No new record was created.',
  'waybills.imports.refresh': 'Refresh',
  'waybills.imports.upload.invalid-type': 'You can upload only PDF files.',
  'waybills.imports.upload.queued': '{name} queued for parsing',
  'waybills.imports.upload.failed-generic': 'Upload failed. Please try again or remove this row.',
  'waybills.imports.upload.failed-after-leave':
    '{name} was not uploaded: {error}. Drop it on Waybill PDF imports again.',
  'waybills.imports.upload.not-sent-signed-out':
    'Files still waiting in the upload queue were not sent: the session that queued them has ended. Sign in and drop them again.',
  'waybills.imports.split.title': 'Several waybills in one PDF',
  'waybills.imports.split.hint': 'One waybill per page — each page becomes its own import. Click or drag a PDF here.',
  'waybills.imports.split.splitting': 'Splitting {name}…',
  'waybills.imports.split.done': '{name}: split into {count} waybills',
  'waybills.imports.split.failed':
    'Could not split this PDF: it is password-protected or damaged. Nothing was uploaded.',
  'waybills.imports.split.confirm.title': 'Split into {count} waybills?',
  'waybills.imports.split.confirm.content':
    '{name} has {count} pages. Each page becomes its own waybill import and one Gemini call.',
  'waybills.imports.split.confirm.ok': 'Split',
  'waybills.imports.split.confirm.cancel': 'Cancel',
  'waybills.imports.split.unavailable': 'Could not prepare this PDF for splitting. Refresh the page and try again.',
  'waybills.imports.split.pages-failed-after-leave':
    'Some pages of {name} were not uploaded: {error}. When its other pages have finished parsing, drop {name} again into "Several waybills in one PDF" on Waybill PDF imports: parsed pages are recognised as duplicates.',
  'waybills.imports.split.not-asked-after-leave':
    '{name} ({count} pages) was not split: it needs your confirmation and Waybill PDF imports was closed. Drop it there again.',
  'waybills.imports.delete.unreachable':
    "Couldn't reach the server. Your delete may not have completed — please refresh to verify.",
  'waybills.imports.column.file': 'File',
  'waybills.imports.column.status': 'Status',
  'waybills.imports.column.created': 'Created',
  'waybills.imports.column.result': 'Result',
  'waybills.imports.column.actions': 'Actions',
  'waybills.declaredNetWeightKg': 'Net weight (kg)',
  'waybills.imports.result.waybill-link': 'Waybill #{id}',
  'waybills.imports.result.warnings': '{count, plural, one {# warning} other {# warnings}}',
  'waybills.add-lab-analyses-from-excel': 'Add Analyses from Excel',
  'waybills.lab-analyses.create-from-excel': 'Waybill analysis from excel',
  'waybills.link-with-farmers-from-excel': 'Link Farmers from Excel',
  'waybills.link-with-farmers-from-excel.success': 'Farmers have been successfully linked from the Excel file.',
  'waybills.link-with-farmers-from-excel.upload-title': 'Click or drag Excel files here to upload',
  'waybills.link-with-farmers-from-excel.upload-hint':
    'Multiple Excel files are supported (.xls, .xlsx), up to 20 files per upload. Each file is processed in order.',
  'waybills.link-with-farmers-from-excel.batch.no-files': 'Please add at least one file.',
  'waybills.link-with-farmers-from-excel.batch.too-many': 'You can upload at most {max} files at once.',
  'waybills.link-with-farmers-from-excel.batch.invalid-extension': 'Only Excel files (.xls, .xlsx) are allowed.',
  'waybills.link-with-farmers-from-excel.batch.success-all': 'All {count} files were processed successfully.',
  'waybills.link-with-farmers-from-excel.batch.partial-title': 'Import finished: {ok} succeeded, {fail} failed',
  'waybills.link-with-farmers-from-excel.batch.all-failed-title': 'Import failed for every file',
  'waybills.mass-add-product': 'Associate Product',
  'waybills.mass-add-factory': 'Associate Factory',
  'waybills.mass-remove': 'Delete Waybills',
  'waybills.delete-warning-title': 'Warning',
  'waybills.delete-warning-desc': 'Are you sure you want to delete these waybills?',
  'waybills.latestSupplierName': 'Cooperative',
  'waybills.cooperativeConsortiums': 'Consortiums',
  'waybills.latestSupplierCode': 'Code CCC',
  'waybills.latestWeightingCode': 'Weighing Code',
  'waybills.latestOriginDepartment': 'Origin',
  'waybills.latestAnalyzedAt': 'Entry Date',
  'waybills.latestNatGrade': 'Latest Nat Grade',
  'waybills.latestFccGrade': 'Latest Fcc Grade',
  'waybills.latestBags': 'Accepted Number of Bags',
  'waybills.latestAcceptedWeight': 'Accepted Weight (kg)',
  'waybills.latestCccExportDatetime': 'Latest CCC Export Datetime',
  'waybills.noData': 'No data',
  'waybills.farmers.section': 'Section',
  'waybills.farmers.netWeightKg': 'Net Weight (kg)',
  'waybills.farmers.bagsCount': 'Bags Count',
  'waybills.farmers.purchaseDate': 'Purchase Date',
  'waybills.farmers.receiptNumber': 'Receipt Number',
  'waybills.lot.title': 'Latest Lot Number is #{0}',
  'waybills.lot.number': 'Lot Number',
  'waybills.tabs.lots': 'Lots',
  'waybills.lots.lotNumber': 'Lot Number',
  'waybills.lots.createdAt': 'Created At',
  'waybills.lots.updatedAt': 'Updated At',

  'waybill.addLot': 'Add Lot',
  'waybill.attachLot': 'Attach Lot',
  'waybill.attachLot.title': 'Attach Waybill to Existing Lot (#{0})',
  'waybill.factory.title': 'Associate Factory for Waybills #{0}',
  'waybill.product.title': 'Associate Product for Waybills #{0}',
  'waybill.weighing-analysis.title': 'Analysis for Waybill #{0}',
  'waybill.weighing-analysis.weighing-code': 'Weighing Code',
  'waybill.weighing-analysis.cooperative': 'Cooperative',
  'waybill.weighing-analysis.cooperative-code': 'Cooperative Code',
  'waybill.weighing-analysis.exporter': 'Exporter',
  'waybill.weighing-analysis.origin-department': 'Origin Department',
  'waybill.weighing-analysis.bags-count': 'Bags Count',
  'waybill.weighing-analysis.accepted-weight': 'Accepted Weight',
  'waybill.weighing-analysis.nat-grade': 'Nat Grade',
  'waybill.weighing-analysis.fcc-grade': 'Fcc Grade',
  'waybill.weighing-analysis.ccc-export-datetime': 'CCC Export Datetime',
  'waybill.weighing-analysis.weighing-date': 'Weighing Date',
  'waybill.weighing-analysis.analysis-date': 'Analysis Date',
  'waybill.weighing-analysis.bulletin-number': 'Bulletin Number',
  'waybill.weighing-analysis.controller': 'Controller',
  'waybill.weighing-analysis.humidity': 'Humidity',
  'waybill.weighing-analysis.foreign-materials': 'Foreign Materials',
  'waybill.weighing-analysis.graininess': 'Graininess',
  'waybill.weighing-analysis.slate-beans': 'Slate Beans',
  'waybill.weighing-analysis.moldy-beans': 'Moldy Beans',
  'waybill.weighing-analysis.broken-beans': 'Broken Beans',
  'waybill.weighing-analysis.waste': 'Waste',
  'waybill.weighing-analysis.crabots': 'Crabots',
  'waybill.weighing-analysis.defective-beans': 'Defective Beans',
  'waybill.weighing-analysis.violet-beans': 'Violet Beans',

  'attachment-history.name': 'File Name',
  'attachment-history.type': 'Type',
  'attachment-history.object': 'Object',
  'attachment-history.size': 'Size',
  'attachment-history.mimetype': 'Format',
  'attachment-history.uploadedBy': 'Uploaded By',
  'attachment-history.createdAt': 'Uploaded At',
  'attachment-history.attachment-type.CV': 'CV',
  'attachment-history.attachment-type.BV': 'BV',
  'attachment-history.attachment-type.ContractLineItem': 'Contract line item',
  'attachment-history.attachment-type.CVExecution': 'CV execution',
  'attachment-history.attachment-type.CooperativeLegal': 'Cooperative (legal)',
  'attachment-history.attachment-type.CooperativePolygon': 'Cooperative polygon',
  'attachment-history.attachment-type.Lot': 'Lot',
  'attachment-history.attachment-type.LotAnalysis': 'Lot analysis',
  'attachment-history.attachment-type.LotFumigation': 'Lot fumigation',
  'attachment-history.attachment-type.LotPledge': 'Lot pledge',
  'attachment-history.attachment-type.LotWeighing': 'Lot weighing',
  'attachment-history.attachment-type.Waybill': 'Waybill',
  'attachment-history.attachment-type.Transfer': 'Transfer',
  'attachment-history.attachment-type.Other': 'Other',
};
